var _path, _path2, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.7692C0 33.4947 9.50534 43 21.2308 43C22.7602 43 24 41.7602 24 40.2308V5C24 2.23857 21.7614 0 19 0H5C2.23858 0 0 2.23857 0 5V21.7692Z",
    fill: "url(#paint0_linear_1947_12022)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46703 43.0003C3.79082 43.0003 0 39.2095 0 34.5332V17.1448C0 12.4686 3.79082 8.67773 8.46703 8.67773H34.6044C39.2806 8.67773 43.0714 12.4686 43.0714 17.1448V22.5414C42.854 22.4972 42.6289 22.4741 42.3984 22.4741H34.3225C32.4641 22.4741 30.9576 23.9806 30.9576 25.839C30.9576 27.6974 32.4641 29.204 34.3225 29.204H42.3984C42.6289 29.204 42.854 29.1808 43.0714 29.1366V34.5332C43.0714 39.2095 39.2806 43.0003 34.6044 43.0003H8.46703Z",
    fill: "#DBC8A7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.8407,
    cy: 25.8407,
    r: 1.84066,
    fill: "url(#paint1_linear_1947_12022)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1947_12022",
    x1: 2.11765,
    y1: 28.2188,
    x2: 43.7193,
    y2: 19.3694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBC8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A262"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1947_12022",
    x1: 35.3248,
    y1: 26.4159,
    x2: 41.1488,
    y2: 24.1962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBC8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A262"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.e4497099a0272e8c1e72fc9931f0aaa1.svg";
export { ForwardRef as ReactComponent };